const CartLineUiState = Object.freeze({
    REMOVING: 'removing',
    RETURNING: 'returning',
    ADDING: 'adding',
    MODIFYING: 'modifying',
});

/**
 * Set a variable to easily give us more information about the state of a cartLine.
 *
 * @param {CartLine} cartLine
 *
 * @returns {string|null}
 */
const calculateCartLineUiState = (cartLine) => {
    // This should never occur in use but checking for existence of these objects makes testing easier.
    if (!cartLine.cart || !cartLine.cart.currentCart) {
        return null;
    }
    if (cartLine.cart.currentCart.isEditingOrder) {
        if (cartLine.quantity < 1) {
            return CartLineUiState.REMOVING;
        }

        if (cartLine.qtyBeforeAdjustment === 0) {
            return CartLineUiState.ADDING;
        }

        if (cartLine.quantity !== cartLine.qtyBeforeAdjustment) {
            return CartLineUiState.MODIFYING;
        }
    }

    if (cartLine.quantity < 0) {
        return CartLineUiState.RETURNING;
    }
    return null;
};

module.exports = {
    CartLineUiState,
    calculateCartLineUiState,
};
